<template>
	<section>
		<div v-if="showParentView('page-resource')">
			<header-page
				name="resources"
				:title="$route.meta.title"
			/>
			<resource-list
				:code-project="codeProject"
				:columns="columns"
				:current-page="currentPage"
				:module-id="moduleId"
				:module-name="moduleName"
				:last-page="table.lastPage"
				:rows="table.rows"
				@change-page="changePage"
				@on-delete="loadData('resources')"
				@on-search="onSearch($event, 'resources')"
			/>
			<quick-actions
				:actions="actions"
				@open-modal="openModal"
			>
			</quick-actions>
		</div>
		<router-view></router-view>
	</section>
</template>

<script>
import quickActions from '@/components/shared/quick-actions';
import resourceList from '@/components/resources/resource-list';

function created() {
	this.params.moduleId = this.moduleId;
	this.loadData('resources');
}

function changePage(page) {
	this.params.page = page;
	this.currentPage = page;
	this.loadData('resources');
}

function openModal() {
	this.goTo('page-update-resource-new', { moduleId: this.moduleId, moduleName: this.moduleName });
}

function data() {
	return {
		actions: [
			{
				id: 1,
				code: 'CR',
				text: 'Crear Recurso',
				icon: 'add_box',
				active: true,
			},
		],
		columns: [
			{ id: 1, name: 'Id', checked: true, visible: true },
			{ id: 2, name: 'Nombre', checked: true, visible: true },
			{ id: 3, name: 'Título', checked: true, visible: true },
			{ id: 4, name: 'Url Web', checked: true, visible: true },
			{ id: 5, name: 'Fragment Móvil', checked: true, visible: true },
			{ id: 6, name: 'Posición', checked: true, visible: true },
			{ id: 7, name: 'Acciones', checked: true, visible: true, flagVisible: true },
		],
		currentPage: 1,
	};
}

export default {
	name: 'page-resource',
	created,
	components: {
		resourceList,
		quickActions,
	},
	data,
	methods: {
		changePage,
		openModal,
	},
	props: {
		codeProject: {
			type: String,
			required: true,
		},
		moduleId: {
			type: [Number, String],
			required: true,
		},
		moduleName: {
			type: String,
			required: true,
		},
	},
	watch: {
		$route(newVal) {
			if (newVal) {
				if (newVal.name === 'page-resource') {
					this.params.moduleId = this.moduleId;
					this.loadData('resources');
				}
			}
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/pages/resources/page-resource.vue